import type { FileField } from '@/modules/Project/Fields/types'
import { defineStore } from 'pinia'
import { ref, type Ref } from 'vue'

/**
 * Stores the last previewed file per agent/project (projectId)
 */
export const useAgentUIStore = defineStore('agentUI', () => {
  const lastPreviewedFiles: Ref<Record<string, FileField | undefined>> = ref({})

  function setLastPreviewedFile(file: FileField) {
    lastPreviewedFiles.value[file.projectId] = file
  }

  function getLastPreviewedFile(projectId: string): FileField | undefined {
    return lastPreviewedFiles.value[projectId]
  }

  function clearLastPreviewedFile(projectId: string) {
    lastPreviewedFiles.value[projectId] = undefined
  }

  return {
    setLastPreviewedFile,
    getLastPreviewedFile,
    clearLastPreviewedFile,
  }
})
